import React from "react";
import {
  CreditCardTabIcon,
  MobilePhoneTabIcon,
  WalletTabIcon,
} from "../project-status/FilterTabIcons";

interface TabIconProps {
  className?: string;
}

export const AppGridTabIcon: React.FC<TabIconProps> = ({ className }) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <rect x="1.5" y="1.5" width="4.5" height="4.5" rx="1" stroke="currentColor" strokeWidth="1.1" />
    <rect x="8" y="1.5" width="4.5" height="4.5" rx="1" stroke="currentColor" strokeWidth="1.1" />
    <rect x="1.5" y="8" width="4.5" height="4.5" rx="1" stroke="currentColor" strokeWidth="1.1" />
    <rect x="8" y="8" width="4.5" height="4.5" rx="1" stroke="currentColor" strokeWidth="1.1" />
  </svg>
);

export const ShieldTabIcon: React.FC<TabIconProps> = ({ className }) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M7 1.5L11.5 3.25V6.75C11.5 9.35 9.65 11.55 7 12.5C4.35 11.55 2.5 9.35 2.5 6.75V3.25L7 1.5Z"
      stroke="currentColor"
      strokeWidth="1.15"
      strokeLinejoin="round"
    />
  </svg>
);

export const ECOSYSTEM_TAB_ICONS: Record<string, React.FC<TabIconProps>> = {
  "Apple Wallet": MobilePhoneTabIcon,
  "Google Wallet": WalletTabIcon,
  "App Based": AppGridTabIcon,
  IDP: ShieldTabIcon,
};

export const PeopleSummaryIcon: React.FC<TabIconProps> = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <circle cx="7" cy="6" r="2.5" stroke="currentColor" strokeWidth="1.2" />
    <path
      d="M2.5 15.5C2.5 12.73 4.73 10.5 7.5 10.5H6.5C9.27 10.5 11.5 12.73 11.5 15.5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <circle cx="12.5" cy="5.5" r="2" stroke="currentColor" strokeWidth="1.1" />
    <path
      d="M10 15.5C10.2 13.4 11.55 11.8 13.5 11.5"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
    />
  </svg>
);

export const GlobeSummaryIcon: React.FC<TabIconProps> = ({ className }) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <circle cx="9" cy="9" r="6.75" stroke="currentColor" strokeWidth="1.2" />
    <path d="M2.25 9H15.75" stroke="currentColor" strokeWidth="1.1" />
    <path
      d="M9 2.25C10.8 4.1 11.75 6.45 11.75 9C11.75 11.55 10.8 13.9 9 15.75C7.2 13.9 6.25 11.55 6.25 9C6.25 6.45 7.2 4.1 9 2.25Z"
      stroke="currentColor"
      strokeWidth="1.1"
    />
  </svg>
);
